import { AiChatAdminState } from './AiChatAdmin.page';
import { ChatEntryDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { getSortedChatEntries } from '../ai-chat/ai-chat.utilities';

export const getPaginationConfig = (
  idx: number,
  lastIndex: number,
  pageSize: number
): {
  page: number;
  pageSize: number;
} => {
  const diff = lastIndex - idx;
  const pagesBack = Math.ceil(diff / pageSize);
  return {
    page: pagesBack,
    pageSize
  };
};

export const getAdminSortedChatEntries = (entriesPage: AiChatAdminState['entriesPage']): ChatEntryDto[] => {
  if (!entriesPage || !entriesPage.content) {
    return [];
  }
  return getSortedChatEntries(entriesPage.content);
};
